/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type consents_ConsentOverviewScopeItem = {
    /**
     * ConsentID is the record the state comes from.
     */
    consent_id?: string;
    /**
     * DecidedAt is when the decision was recorded.
     */
    decided_at?: string;
    /**
     * DecidedByName is the recorder's name: the parent contact, or the employee. Absent when neither is on record.
     */
    decided_by_name?: string;
    /**
     * DecidedByUserID is the login that recorded the decision.
     */
    decided_by_user_id?: string;
    /**
     * GrantedByContactID is the guardian the decision is attributed to.
     */
    granted_by_contact_id?: string;
    /**
     * RevokedAt is set when the state is revoked.
     */
    revoked_at?: string;
    /**
     * Scope is the legal basis.
     */
    scope: consents_ConsentOverviewScopeItem.scope;
    /**
     * Source is parent when the guardian decided with their own login, else staff.
     */
    source?: consents_ConsentOverviewScopeItem.source;
    /**
     * State is the display state; revoked means the latest record was revoked and no live record replaces it.
     */
    state: consents_ConsentOverviewScopeItem.state;
    /**
     * ValidFrom is the record's first valid day (YYYY-MM-DD).
     */
    valid_from?: string;
    /**
     * ValidTo is the record's last valid day (YYYY-MM-DD); absent means open-ended.
     */
    valid_to?: string;
};
export namespace consents_ConsentOverviewScopeItem {
    /**
     * Scope is the legal basis.
     */
    export enum scope {
        DOCUMENTATION = 'documentation',
        PHOTO_INTERNAL = 'photo_internal',
        PHOTO_PARENT_VISIBLE = 'photo_parent_visible',
        PRINTED_PORTFOLIO = 'printed_portfolio',
        EXTERNAL_SHARING = 'external_sharing',
    }
    /**
     * Source is parent when the guardian decided with their own login, else staff.
     */
    export enum source {
        PARENT = 'parent',
        STAFF = 'staff',
    }
    /**
     * State is the display state; revoked means the latest record was revoked and no live record replaces it.
     */
    export enum state {
        GRANTED = 'granted',
        REFUSED = 'refused',
        UNKNOWN = 'unknown',
        REVOKED = 'revoked',
    }
}

